/**
 * Hand a written message from one surface to the chat that sends it.
 *
 * Home's composer writes into the organization's new-chat draft (the same
 * draft Chat opens), then navigates to it. Sending stays the chat view's
 * job — one send path, with its attachments, model and failure handling —
 * so Home only marks the draft "send when ready" here, and the chat view
 * takes the mark once its composer can send.
 *
 * @module draftSendHandoff
 */
const pending = new Set<string>();

/** Ask the chat view of this draft to send its composer as soon as it can. */
export function requestDraftSend(draftId: string): void {
  pending.add(draftId);
}

export function hasPendingDraftSend(draftId: string | null): boolean {
  return draftId !== null && pending.has(draftId);
}

/** Claims the request: true once, for the caller that will send. */
export function takeDraftSend(draftId: string | null): boolean {
  return draftId !== null && pending.delete(draftId);
}

/** Drops a request that can no longer be honoured (the draft was discarded). */
export function cancelDraftSend(draftId: string): void {
  pending.delete(draftId);
}
